import React from "react";
import _ from "lodash";
import ReactGoogleSlides from "react-google-slides";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const Slides = ({ room_data }) => {
  const slidekick_url = _.get(room_data, "game_state.slidekick_url");
  const current_slide = _.get(room_data, "game_state.current_slide");
  return (
    <div className="slideKick-viewer-container">
      <div className="image-container">
        <TransformWrapper>
          <TransformComponent>
            <ReactGoogleSlides
              showControls={false}
              position={current_slide}
              slidesLink={slidekick_url}
            />
          </TransformComponent>
        </TransformWrapper>
      </div>
      <div className="btn-container">
        <button className="btn btn-unlike">
          <i className="fal fa-thumbs-down fa-2x"></i>
        </button>
        <button className="btn btn-like">
          <i className="fal fa-thumbs-up fa-2x"></i>
        </button>
      </div>
    </div>
  );
};

export default Slides;
